import { render, staticRenderFns } from "./RegistrazioneInviata.vue?vue&type=template&id=7a4769f4&scoped=true&"
import script from "./RegistrazioneInviata.vue?vue&type=script&lang=js&"
export * from "./RegistrazioneInviata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4769f4",
  null
  
)

export default component.exports